import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeLayoutComponent } from "./home-layout/home-layout.component";
import { ContractSignComponent } from './pages/contract-sign/contract-sign.component';
import { OnlineTrainingComponent } from './pages/online-training/online-training.component';
import { PersonalInfoComponent } from './pages/personal-info/personal-info.component';
import { StepsStatusComponent } from './pages/steps-status/steps-status.component';
import { UploadDocumentsComponent } from './pages/upload-documents/upload-documents.component';
import { DashboardMgaComponent } from './pages/dashboard-mga/dashboard-mga.component';
import { MgaDetailsComponent } from './pages/mga-details/mga-details.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { SalesHomeComponent } from './pages/sales-home/sales-home.component';
import { SalesPolicySearchComponent } from './pages/sales-policy-search/sales-policy-search.component';
import { SavedQuotesComponent } from './pages/saved-quotes/saved-quotes.component';
import { QuotesPurchaseComponent } from './pages/quotes-purchase/quotes-purchase.component';
import { SalesGroupsComponent } from './pages/sales-groups/sales-groups.component';
import { PaymentSuccessComponent } from './pages/payment-success/payment-success.component';
import { SalesReportComponent } from './pages/sales-report/sales-report.component';
import { ReportDetailsComponent } from './pages/report-details/report-details.component';
import { PolicySearchDetailComponent } from './pages/policy-search-detail/policy-search-detail.component';
import { PolicyFullRefundComponent } from './pages/policy-full-refund/policy-full-refund.component';
import { ChangePolicyComponent } from './pages/change-policy/change-policy.component';
import { EditBillingInfoComponent } from './pages/edit-billing-info/edit-billing-info.component';
import { AgencyAdminDashboardComponent } from './pages/agency-admin-dashboard/agency-admin-dashboard.component';
import { FormsDashboardComponent } from './pages/forms-dashboard/forms-dashboard.component';
import { ResourcesDashboardComponent } from './pages/resources-dashboard/resources-dashboard.component';
import { VtcComponent } from './pages/vtc/vtc.component';

import { OfficeAdminSalesReportComponent } from './pages/office-admin-sales-report/office-admin-sales-report.component';
import { OfficeAdminSalesReportDetailsComponent } from './pages/office-admin-sales-report-details/office-admin-sales-report-details.component';
import { NotFound404Component } from '../core/components/not-found404/not-found404.component';
SalesPolicySearchComponent
const routes: Routes = [
  {
    path: "",
    component: HomeLayoutComponent,
    children: [
      {
        path: "steps-status",
        component: StepsStatusComponent
      },
      {
        path: "",
        component: PersonalInfoComponent
      },
      {
        path: "personal-info",
        component: PersonalInfoComponent
      },
      {
        path: "upload-documents",
        component: UploadDocumentsComponent
      },
      {
        path: "contract-sign",
        component: ContractSignComponent
      },
      {
        path: "online-training",
        component: OnlineTrainingComponent
      },
      {
        path: "dashboard-mga",
        component: DashboardMgaComponent
      },
      {
        path: "mga-details/:id",
        component: MgaDetailsComponent
      },
      {
        path: "contactus",
        component: ContactUsComponent
      },
      {
        path: "sales-home",
        component: SalesHomeComponent
      },
      {
        path: "policy-search",
        component: SalesPolicySearchComponent
      },
      {
        path: "Save-Quotes",
        component: SavedQuotesComponent
      },
      {
        path: "Quotes-Purchase",
        component: QuotesPurchaseComponent
      },
      {
        path: "Groups",
        component: SalesGroupsComponent
      },
      {
        path: "payment",
        component: PaymentSuccessComponent
      },
      {
        path: "sales-report",
        component: SalesReportComponent
      },
      {
        path: "report-details",
        component: ReportDetailsComponent
      },
      {
        path: "policy-details",
        component: PolicySearchDetailComponent
      },
      {
        path: "policy-full-refund",
        component: PolicyFullRefundComponent
      },
      {
        path:"change-policy",
        component:ChangePolicyComponent
      },
      {
        path:"edit-billing-info",
        component:EditBillingInfoComponent
      },
      {
        path:"agency-admin",
        component:AgencyAdminDashboardComponent
      },
      {
        path:"forms",
        component:FormsDashboardComponent
      },
      {
        path:"resources",
        component:ResourcesDashboardComponent
      },
      {
        path: "vtc",
        component: VtcComponent
      },
      {
        path:"OASale-report",
        component:OfficeAdminSalesReportComponent
      },
      {
        path:"OASale-report-details",
        component:OfficeAdminSalesReportDetailsComponent
      },
      // {
      //   path: "page-not-found",
      //   component: NotFound404Component
      // },
    ]
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
